<template>
  <van-uploader
    :accept="accept"
    :after-read="afterRead"
    :before-delete="beforeDelete"
    :file-list="fileList"
    :max-count="maxCount"
    :max-size="maxSize"
    result-type="file"
    @oversize="onOversize"
  />
</template>

<script>
import { UPLOAD_CONFIG } from '@/constant/config'
import api from '@/api'
import axios from 'axios'

export default {
  name: 'WhUpload',
  model: {
    prop: 'fileList',
    event: 'change'
  },
  props: {
    /*
    * 文件列表
    * */
    fileList: {
      type: Array,
      default() {
        return []
      }
    },
    /*
    * 限制上传数量
    * */
    maxCount: {
      type: Number,
      default: 10
    },
    /*
    * 限制上传大小 (默认10M)
    * */
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024
    },
    /*
    * 上传文件类型
    * */
    accept: {
      type: String,
      default: 'image/png,image/jpg, image/jpeg'
    },
    /*
    * 上传文件url
    * */
    uploadUrl: {
      type: String,
      default() {
        return UPLOAD_CONFIG.uploadUrl
      }
    },
    size: {
      type: Number,
      default: undefined
    },
    // 是否有文件在上传中
    uploading: {
      type: Boolean,
      default: false
    },
    filesStr: {
      type: String,
      default: ''
    }
  },
  watch: {
    fileList: {
      handler(newVal) {
        const keys = []
        newVal.forEach(item => {
          if (item.key) {
            keys.push(item.key) // 存储key值
            item.name = item.key // 更新文件名为key值
          }
          if (this.size && !('previewSize' in item)) {
            this.$set(item, 'previewSize', this.size)
          }
        })
        this.$emit('update:filesStr', keys.join(','))
        // 如果没有传入尺寸数据，使用size参数定义尺寸
      }
    },
    immediate: true
  },
  methods: {
    onOversize(file) {
      this.$toast(`文件大小不能超过 ${this.maxSize}M`)
    },
    beforeDelete(file, detail) {
      this.removeFileByIndex(file.url, detail.index)
    },
    afterRead(file, detail) {
      this.$emit('update:uploading', true)
      file.url = URL.createObjectURL(file.file)
      file.status = 'uploading'
      file.message = `上传中...`
      this.fileList.push(file)
      api.getUploadToken().then(({ data: token }) => {
        const fileName = file.file.name.replace(/[\[\]%@,]/g, '')
        const formData = new FormData()
        formData.append('token', token)
        formData.append('key', new Date().getTime() + '_' + fileName)
        formData.append('file', file.file)
        axios.post(this.uploadUrl, formData, {
          onUploadProgress: progressEvent => {
            const progress = (progressEvent.loaded / progressEvent.total * 100) | 0
            file.message = `上传${progress}%`
            if (progress === 100) {
              file.status = 'done'
            }
          }
        }).then(({ data: { key }}) => {
          this.$set(file, 'key', key)
          this.$emit('change', this.fileList)
          this.$emit('update:uploading', false)
        }).catch(() => {
          this.$toast('文件上传失败')
          this.removeFileByIndex(file.url, detail.index)
        })
      }).catch(() => {
        this.removeFileByIndex(file.url, detail.index)
        this.$toast('获取文件上传信息失败')
      })
    },
    removeFileByIndex(url, index) {
      URL.revokeObjectURL(url)
      this.fileList.splice(index, 1)
      this.$emit('change', this.fileList)
    }
  }
}
</script>
<style lang="less" scoped>
.van-uploader {
  width: 100%;
  /deep/ .van-uploader__wrapper {
    width: 100%;
    display: grid;
    grid-row-gap: 5px;
    justify-content: space-around;
    grid-template-columns: repeat(4, auto);
    .van-uploader__preview, .van-uploader__upload {
      margin: 0 auto !important;
    }
  }

}
</style>
